import Axios from "axios";
// Actions
import {
    SEND_PLAN_DEMAND,
    UPDATE_ADRESS,
    UPDATE_CITY,
    UPDATE_FIRSTNAME,
    UPDATE_LASTNAME,
    UPDATE_PHONE_NUMBER,
    UPDATE_USER,
    UPDATE_ZIP_CODE
} from "../actions/PlanDemand";
import {setRedirection} from "../actions/user";
import {setErrorApiMessage} from "../actions/apiFlag";
// Utils
import {getApiBaseUrl} from "../utils/baseUrl";

// On définit par défaut un TimeOut Axios à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const planDemand = (store) => (next) => (action) => {
    switch (action.type) {
// Action permettant d'envoyer la demande effectué via le Chat
        case SEND_PLAN_DEMAND : {
// Destructuring du state
            const state = store.getState();
            const {planDemand} = state;
            console.log("plan demand in miidlewares", planDemand);

            const url = `${getApiBaseUrl()}/createDemand/`;

//Option pour formaté la date
//             const options = {month: "long", day: "2-digit", year: "numeric"};

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "contenu": planDemand.userInfos.resume, // Description de la situation que le user a rempli dans le chatbot
                // "date": planDemand.selectedDay.toLocaleDateString("fr-Fr", options), // Correspond à la date sélectionnée via le calendrier du chatbot
                // "hours": planDemand.selectedTime // Correspond au créneau horaire choisit dans le chatbot
            };
            console.log("payload in send plan demand middleware", payload);
            Axios.post(url, payload, {withCredentials: true})
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                        console.log("err401", err);
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                        console.log("errECONNABORTED", err);
                    }
                });
        }
            next(action);
            break;
// Permet d'update les coordonnées du user en BDD
        case UPDATE_USER : {
            const url = `${getApiBaseUrl()}/updateUser/`;
// Destructuring du State
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "firstname": userInfos.firstname,
                    "name": userInfos.lastname,
                    "adress": userInfos.road,
                    "city": userInfos.city,
                    "cp": userInfos.cp
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
// Update du prénom
        case UPDATE_FIRSTNAME : {
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "firstname": userInfos.firstname,
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }

                });
        }
            next(action);
            break;
// Update du nom
        case UPDATE_LASTNAME : {
// Destructuring du state
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;

            const url = `${getApiBaseUrl()}/updateUser/`;
            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "name": userInfos.lastname,
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
// Update de l'adresse en BDD
        case UPDATE_ADRESS : {
// Destructuring du state
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "adress": userInfos.route,
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
// Update de la ville
        case UPDATE_CITY : {
// Destructuring du state
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;

            const url = `${getApiBaseUrl()}/updateUser/`;
            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "city": userInfos.city,
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }

                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }

                });
        }
            next(action);
            break;
// Update du code postal (cp)
        case UPDATE_ZIP_CODE : {
// Destructuring du state
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;

            const url = `${getApiBaseUrl()}/updateUser/`;
            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "cp": userInfos.cp,
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
// Update du numéro de téléphone
        case UPDATE_PHONE_NUMBER : {
// Destructuring du state
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;

            const url = `${getApiBaseUrl()}/updateUser/`;
            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "tel": userInfos.tel,
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
        default:
            next(action);
    }
};

export default planDemand;